// @flow

import { useCallback, useMemo } from 'react';
import { detectCardBrand, type CardBrand } from '@tectonics/prs/card-brand';
import { useUserInputValue } from '@tectonics/prs/user-input-values';
import { formatValueWithMask } from '@tectonics/components/input-mask';
import { getCardBrandMask } from './get-card-brand-mask';
import { type CardMask } from './types';

export function useFormatRawForCardBrandMask(): [(string) => string, CardMask, ?CardBrand] {
  const [cardNumber] = useUserInputValue('cardNumber');
  const cardBrand = useMemo(() => detectCardBrand(cardNumber), [cardNumber]);
  const cardMask = useMemo(() => getCardBrandMask(cardBrand), [cardBrand]);
  const formatRaw = useCallback((rawValue: string) => formatValueWithMask(rawValue, cardMask), [cardMask]);
  return useMemo(() => [formatRaw, cardMask, cardBrand], [formatRaw, cardMask, cardBrand]);
}
